export default __webpack_public_path__ + "static/media/ortolab.7b5b0c5e.png";